import React from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';

import {getProfilesByName, setProfiles} from "../../redux/actions/profile";

import TagsInput from 'react-tagsinput';

import ProductGeneralAutosuggest from "./ProductGeneralAutosuggest/ProductGeneralAutosuggest.jsx";


class ProductProfileTags extends React.Component {
    constructor(props) {
        super(props);

        this.debouncedGetProfiles = _.debounce((name) => this.props.getProfilesByName(name), 1000);
    }

    componentWillUnmount() {
        this.props.setProfiles([]);
    }

    render () {
        return <TagsInput
            renderInput={ProductGeneralAutosuggest}
            value={this.props.value}
            onChange={this.props.onChange}
            tagProps={{className: 'react-tagsinput-tag tag-fill tag-azure' }}
            inputProps={{
                suggestions: this.props.profiles,
                clearSuggestions: () => {this.props.setProfiles([])},
                getSuggestions: (val) => {this.debouncedGetProfiles(val)},
                placeholder: this.props.placeholder,
                style: {width: '100%'},
                nameColumn: "name"
            }}
        />
    }
}

const mapStateToProps = state => {
    return {
        loadingProfiles: state.status.loadingProfiles,
        profiles: state.profiles.profiles
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getProfilesByName: name => {
            dispatch(getProfilesByName(name));
        },
        setProfiles: val => {
            dispatch(setProfiles(val));
        }
    }
};

ProductProfileTags.propTypes = {
    loadingProfiles: PropTypes.bool,
    profiles: PropTypes.array,

    getProfilesByName: PropTypes.func,
    setProfiles: PropTypes.func,

    onChange: PropTypes.func,

    value: PropTypes.array,
    placeholder: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductProfileTags);